<template>
    <div class="bg-white p-2 roundedDiv position-relative  h-100 card "  @click="navigateToStore(rs)">

      <div class=" card-body">

        <div class="row" >

          <div :class="'col-12'">
            <h3 class=" mb-3  montserrat-700" style="font-size: 18px">{{ rs.StoreTitle }}</h3>
<!--            <h3 v-if="rs.StoreTitle" class=" mb-3  montserrat-500 "  style="font-size: 18px" >{{ rs.StoreTitle }}</h3>-->
          </div>

          <div v-if="storeClosed(rs)">
            <a  href="#" class="badge badgeAbsolute  primaryColor mr-3 px-3"  >Closed</a>
          </div>
        </div>




      <p class="montserrat-400">{{rs.Location.Address}}
        <br />
        {{rs.Location.Suburb}} {{rs.Location.State}} {{rs.Location.Postcode}}
        <br />
        PH: {{rs.OfficePhone}}</p>
        <div class="mb-3">
            <h4 class=" montserrat-700 ">Opening Hours</h4>
            <p class="montserrat-400 ">{{getOperatingHours(rs, true).openTime}} to {{getOperatingHours(rs, true).closeTime}}</p>
        </div>
      </div>
<!--      <span v-if="pos" class="fs-90">-->
<!--                              <i class="material-icons">near_me</i>-->
<!--                              {{ distance(rs.Location.Latitude, rs.Location.Longitude) }}km-->
<!--                              {{ $t("message.away") }}-->
<!--                            </span>-->

        <div class="container mb-2" >
            <button @click="navigateToStore(rs)" class="btn px-3 text-white font-weight-bolder roundedButton primaryColorBg montserrat-600  "  >Order Now</button>
        </div>

    </div>
</template>

<script>
import shared from "@/sharedscripts/master/Resturant/ResturantsFilter";

export default {
name: "SushiCard",

  props : ["rs", "pos"],
  methods: {
    ...shared.methods,
  },


}


</script>

<style scoped>
.roundedDiv {
  border-radius: 20px
}
.roundedButton {
  border-radius: 5px
}


.badgeAbsolute {
  position: absolute;
  right: 0;
  /*top: 5px;*/
  top: 0;
  border: 1px solid #F04653 ;
  border-radius: 3px;


}

.primaryColorBg {
  background-color: #F04653
}
.primaryColor {
  color: #F04653
}

.card-footer {
  background: transparent;
  border-top: 0px;
}

.card {
  background: transparent;
  border: 0px;
}

</style>
